import { defineMessages } from 'react-intl-next';

export default defineMessages({
	rovoButton: {
		id: 'ai-smart-button.ai-button.button-label',
		defaultMessage: 'Rovo Button',
		description: 'The visually-hidden label for the button to open Rovo',
	},
});
